import React, { useState } from "react";
import { useHistory } from "react-router";
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  Popover,
  TextField,
  Typography,
  Divider,
  Tooltip,
} from "@material-ui/core";
import { Plus, UploadSimple, MagnifyingGlass, File } from "phosphor-react";
import {
  FilterButton,
  SortButton,
  ToggleButton,
} from "../../CommonComponents/CommonButtons/CommonButtons.Component";
import useStyles from "./ProjectMediaTools.style";
import ProjectMediaBreadCrumbs from "./ProjectMediaBreadCrumbs";
import ProjectMediaFilterModal from "../ProjectMediaModals/ProjectMediaFilterModal/ProjectMediaFilterModal";
import FolderIcon from "../../Utilities/Svg/FolderIcon";

const ProjectMediaTools = ({
  handleToggleView,
  handleOpenUploadFolderModal,
  handleOpenAddMediaModal,
  breadCrumbs,
  breadCrumbsId,
  projectId,
  handleSubmitSort,
  sortByDefault,
  projectUsers,
  selectedUser,
  startDate,
  endDate,
  handleEndDate,
  handleStartDate,
  handleSlectedUser,
  handleFilter,
  clearFilter,
  changeSearchQuery,
  searchQuery,
  globalSearchMedias,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterModal, setFilterModal] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenFilterModal = (event) => {
    setFilterModal(event.currentTarget);
  };

  const handleCloseFilterModal = () => {
    setFilterModal(null);
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        console.log("");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  function extractLastPart(input) {
    const parts = input.split("/");
    return parts.length > 2
      ? parts.slice(-2).join("/")
      : input.startsWith("/")
      ? input.slice(1)
      : input;
  }

  return (
    <Grid container alignContent="center" className={classes.root}>
      <Grid item md={6}>
        <ProjectMediaBreadCrumbs
          breadCrumbs={breadCrumbs}
          breadCrumbsId={breadCrumbsId}
          projectId={projectId}
          handleCopy={handleCopy}
        />
      </Grid>
      <Grid item md={6} alignContent="center">
        <Grid
          container
          spacing={2}
          alignContent="center"
          justifyContent="flex-end"
          className={classes.projectMediaPageToolsGrid}
        >
          <Grid item style={{ position: "relative" }}>
            <div className={classes.searchIconContainer}>
              <MagnifyingGlass size={20} />
              <TextField
                placeholder="Search Folders or Files"
                InputProps={{ disableUnderline: true }}
                value={searchQuery}
                onChange={(event) => {
                  changeSearchQuery(event.target.value);
                }}
              />
            </div>
            {searchQuery && (
              <div className={classes.menuPop2}>
                <>
                  {globalSearchMedias.folder.map((eachFolder) => {
                    return (
                      <>
                        <MenuItem
                          className={`${classes.menuItems} ${classes.menuItemCustom}`}
                          onClick={() => {
                            history.push(
                              `/${projectId}/project-media/${eachFolder.id}`,
                              {
                                shallow: true,
                              }
                            );
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <FolderIcon size={18} />
                            <Typography style={{ fontSize: "13px" }}>
                              {eachFolder.name}
                            </Typography>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <Tooltip
                              title={
                                eachFolder.root &&
                                extractLastPart(eachFolder.root)
                              }
                            >
                              <Typography className={classes.menuName}>
                                {eachFolder.root &&
                                  extractLastPart(eachFolder.root)}
                              </Typography>
                            </Tooltip>
                            <Typography className={classes.menuDate}>
                              {new Intl.DateTimeFormat("en-US", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }).format(new Date(eachFolder.updated_at))}
                            </Typography>
                          </div>
                        </MenuItem>
                        <Divider />
                      </>
                    );
                  })}
                  {globalSearchMedias.files.map((eachFile) => {
                    return (
                      <>
                        <MenuItem
                          className={`${classes.menuItems} ${classes.menuItemCustom}`}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "5px",
                          }}
                          onClick={() => {
                            if (eachFile.id_path) {
                              history.push(
                                `/${projectId}/project-media/${eachFile.id_path
                                  .split("/")
                                  .pop()}`,
                                {
                                  shallow: true,
                                }
                              );
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <File size={18} />
                            <Typography className={classes.menuName}>
                              {eachFile.file_name}
                            </Typography>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <Typography className={classes.menuName}>
                              {eachFile.file_path &&
                                extractLastPart(eachFile.file_path)}
                            </Typography>
                            <Typography className={classes.menuDate}>
                              {new Intl.DateTimeFormat("en-US", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }).format(new Date(eachFile.updated_at))}
                            </Typography>
                          </div>
                        </MenuItem>
                        <Divider />
                      </>
                    );
                  })}
                </>
              </div>
            )}
          </Grid>
          <Grid item>
            <ToggleButton
              handleToggler={() => handleToggleView()}
              showGridIcon={true}
            />
          </Grid>
          <Grid item>
            <div>
              <SortButton
                onSubmit={handleSubmitSort}
                defaultvalue={sortByDefault}
              />
            </div>
          </Grid>
          <Grid item>
            <FilterButton
              btnActive={false}
              openFilterModal={handleOpenFilterModal}
            />
            <Popover
              open={filterModal !== null}
              anchorEl={filterModal}
              onClose={handleCloseFilterModal}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{ className: `${classes.paperProp}` }}
            >
              <ProjectMediaFilterModal
                handleClose={handleCloseFilterModal}
                projectUsers={projectUsers}
                selectedUser={selectedUser}
                startDate={startDate}
                endDate={endDate}
                handleEndDate={handleEndDate}
                handleStartDate={handleStartDate}
                handleSlectedUser={handleSlectedUser}
                handleFilter={handleFilter}
                clearFilter={clearFilter}
              />
            </Popover>
          </Grid>
          <Grid item>
            <Button
              size="medium"
              startIcon={<Plus className={classes.plusIcon} />}
              className={classes.addNewFolderButton}
              disableElevation
              onClick={handleClick}
            >
              New
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              style={{ marginTop: "50px" }}
              MenuListProps={{ className: `${classes.menuPop}` }}
            >
              <MenuItem
                className={classes.menuItems}
                onClick={() => {
                  handleOpenUploadFolderModal();
                  handleClose();
                }}
              >
                <Plus className={classes.plusIcon} />
                Add New Folder
              </MenuItem>
              <MenuItem
                className={classes.menuItems}
                onClick={() => {
                  handleOpenAddMediaModal();
                  handleClose();
                }}
              >
                <UploadSimple className={classes.plusIcon} />
                Upload Media
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProjectMediaTools;
